import { Button, DatePicker, Modal, Select, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UploadOutlined } from "@ant-design/icons";
import { ErrorToast, ShowInputError, SuccessToast } from "../../../widgets/AppToast";
import { get, post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import TextAreaInput from "../../../components/TextAreaInput";
import "react-medium-image-zoom/dist/styles.css";
import VoyageDetails from "../../../components/VoyageDetails";
import useImageUpload from "../../../hooks/useImageUpload";
import moment from "moment";

function EditDailyShipStaffTask() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [task_details, set_task_details] = useState("");
  const [department, set_department] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  // Pass initialPhotos from API to useImageUpload
  const [initialPhotos, setInitialPhotos] = useState([]);
  const { fileList, handleFileChange, processFilesToBase64 } = useImageUpload(initialPhotos);
  const [logDate, set_LogDate] = useState(null);
  const [component, set_component] = useState("");
  const [componentList, setComponentList] = useState([]);

  const FETCH_COMPONENT_LIST = () => {
    post(ApiURL.list_daily_task_components_st, new FormData()).then((res) => {
      if (res?.status == true) {
        setComponentList(res?.data || []);
      }
    });
  };

  const VIEW_DAILY_SHIP_STAFF_TASK_APIS = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("task_report_id", atob(id));
    FORM_DATA.append("request_type", "view");
    post(ApiURL.daily_task_details_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        const dailyData = res;
        set_task_details(dailyData?.task_details);
        set_department(dailyData?.department);
        setInitialPhotos(dailyData.photos);
        set_LogDate(dailyData?.log_date_time);
        set_component(dailyData?.component || "");
      } else {
        const errors = res?.errors || {};
        set_errors(errors);
      }
    });
  };

  const UPDATE_DAILY_SHIP_STAFF_TASK_APIS = async () => {
    set_loader(true);
    const base64Images = await processFilesToBase64();

    const FORM_DATA = new FormData();
    FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
    FORM_DATA.append("task_details", task_details);
    FORM_DATA.append("department", department);
    FORM_DATA.append("log_date_time", logDate || "");
    FORM_DATA.append("component", component);
    base64Images.forEach((image) => {
      FORM_DATA.append("photos", JSON.stringify(image));
    });
    FORM_DATA.append("task_report_id", atob(id));
    FORM_DATA.append("request_type", "edit");

    post(ApiURL.daily_task_details_st, FORM_DATA)
      .then((res) => {
        if (res?.status == true) {
          set_loader(false);
          SuccessToast(
            "Congratulation!!",
            "Update Daily Ship Staff Task Details Successfully Updated!!"
          );
          navigate("/list-daily-ship-staff-task");
        } else {
          ErrorToast("Error message", res?.message);
          const errors = res?.errors || {};
          set_errors(errors);
          set_loader(false);
        }
      })
      .catch((error) => {
        console.error("Update API failed:", error);
        set_loader(false);
      });
  };

  const handleChange = (info) => {
    handleFileChange(info);
  };

  const handlePreview = async (file) => {
    let src = file.url;
    if (!src && file.originFileObj) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    setPreviewImage(src);
    setPreviewTitle(file.name);
    setPreviewVisible(true);
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    VIEW_DAILY_SHIP_STAFF_TASK_APIS();
    FETCH_COMPONENT_LIST();
  }, []);
  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <br />
        <h3>Daily Ship Staff Task Information </h3>
        <br />
        <div className="row">
          <div className="col-12">
            <div className="input-box">
              <label>Select Photo</label>
              <Upload
                accept="image/*"
                multiple
                fileList={fileList}
                onChange={handleChange}
                onPreview={handlePreview}
                beforeUpload={() => false}
                listType="picture-circle"
              >
                <Button
                  icon={<UploadOutlined />}
                  type="primary"
                  style={{
                    borderRadius: "50%",
                    padding: "10px",
                    width: "40px",
                    height: "40px",
                  }}
                ></Button>
              </Upload>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time</label>
              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="Select Date & Time"
                value={logDate ? moment(logDate, "YYYY-MM-DD HH:mm:ss") : null}
                onChange={onChangeDateTime}
                style={{ width: "100%" }}
              />

              {errors.log_date_time && <ShowInputError errorMessage={errors.log_date_time} />}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Department</label>
              <Select
                value={department}
                placeholder="--Select Department --"
                style={{ width: "100%" }}
                onChange={(value) => set_department(value)}
              >
                <Select.Option value="Engine">Engine</Select.Option>
                <Select.Option value="Deck">Deck</Select.Option>
                <Select.Option value="Galley">Galley</Select.Option>
              </Select>
              {errors.department && <ShowInputError errorMessage={errors.department} />}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Component</label>
              <Select
                value={component || undefined}
                placeholder="--Select Component --"
                style={{ width: "100%" }}
                onChange={(value) => set_component(value)}
                showSearch
                filterOption={(input, option) =>
                  (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                }
              >
                {componentList?.map((item) => (
                  <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
              {errors.component && <ShowInputError errorMessage={errors.component} />}
            </div>
          </div>
          <div className="col-6">
            <TextAreaInput
              label="Task Details"
              rows={2}
              placeholder="Task Details"
              maxLength={1000}
              value={task_details}
              onChange={(e) => set_task_details(e.target.value)}
              errors={errors.task_details}
            />
          </div>
        </div>

        <div className="input-box" style={{ marginTop: "15px" }}>
          <Button
            loading={loader}
            style={{ fontSize: "12px", color: "#fff" }}
            className="save_btn"
            onClick={UPDATE_DAILY_SHIP_STAFF_TASK_APIS}
          >
            Save
          </Button>
        </div>
      </div>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
            maxWidth: "900px",
            maxHeight: "400px",
            objectFit: "contain",
          }}
          src={previewImage}
        />
      </Modal>
    </>
  );
}

export default EditDailyShipStaffTask;
